module.exports = __webpack_public_path__ + "img/ic_whatsapp.d9bda5e9.png";